import { ProductVariant } from "@sgm-frontend/core";

  interface Pagination {
    total_records: number;
    total_pages: number;
    limit: number;
    page: number;
}
 export interface  CouponListResponse {
    pagination: Pagination;
    records: CouponRecord[];
}

export interface CouponRecord {
  id: string;
  creator_id: string;
  name: string;
  code: string;
  start_date: string;        // ISO date string
  end_date: string;          // ISO date string
  usage_limit: number;
  use_count: number;
  amount: number;
  is_active: boolean;
  minimum_spend: number;
  deleted_at: string | null;
  createdAt: string;
  updatedAt: string;
  coupon_products: ProductVariant[];
}

export interface CouponInputPayload {
  name: string;
  code: string;
  start_date: string;        // ISO date string
  end_date: string;          // ISO date string
  usage_limit: number;
  amount: number;
  is_active: boolean;
  minimum_spend: number;
  coupon_products: string[]; // Array of ProductVariant IDs
}
export interface CouponInputStatusPayload {
  is_active: boolean;
  
}

export interface CouponStatusCountResponse {
  active_count: number;
  inactive_count: number;
  
}

